function stylesheet(useActualHostSelector, token) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  return [".slds-global-header__logo", shadowSelector, " {width: 20rem;height: 6.5rem;background-image: url('/resources/servicemax-asset-360-logo.png');background-size: contain;background-repeat: no-repeat;background-position: left center;}.slds-global-header__item", shadowSelector, " {padding: 0;margin: -12px;}"].join('');
}
export default [stylesheet];